import { convertArrayToObject } from '@/helpers/utils'

export default {
  computed: {
    periods () {
      return this.$store.getters.periods
    },
    years () {
      return this.$store.getters.years
    },
    seasons () {
      return this.$store.getters.seasons
    },
    yearsMap () {
      return this.years ? convertArrayToObject(this.years, 'id') : null
    },
    seasonsMap () {
      return this.seasonsDates ? convertArrayToObject(this.seasonsDates, 'id') : null
    },
    seasonsDates () {
      return this.seasons && this.yearsMap ? this.seasons.map(v => {
        return {
          ...v,
          year: v.year ? this.yearsMap[v.year].year : '1970',
          dateStart: (v.start_day < 10 ? '0' : '') + v.start_day + '.' + (v.start_month < 10 ? '0' : '') + v.start_month + '.' + (v.year ? this.yearsMap[v.year].year : '1970'), // remove when null in year will be fixed in api
          dateEnd: (v.end_day < 10 ? '0' : '') + v.end_day + '.' + (v.end_month < 10 ? '0' : '') + v.end_month + '.' + (v.year ? this.yearsMap[v.year].year : '1970') // remove when null in year will be fixed in api
        }
      }).sort(this.sortDate) : null
    },
    periodsDates () {
      return this.periods && this.seasonsMap ? this.periods.map(v => {
        return {
          ...v,
          start_day: this.seasonsMap[v.season_start].start_day,
          start_month: this.seasonsMap[v.season_start].start_month,
          end_day: this.seasonsMap[v.season_end].end_day,
          end_month: this.seasonsMap[v.season_end].end_month,
          dateStart: this.seasonsMap[v.season_start].dateStart,
          dateEnd: this.seasonsMap[v.season_end].dateEnd,
          year: this.seasonsMap[v.season_start].year
        }
      }).map(v => {
        return {
          ...v,
          name: (v.start_day < 10 ? '0' : '') + v.start_day + '.' + (v.start_month < 10 ? '0' : '') + v.start_month + '.' + v.year + ' - ' + (v.end_day < 10 ? '0' : '') + v.end_day + '.' + (v.end_month < 10 ? '0' : '') + v.end_month + '.' + v.year
        }
      }).sort(this.sortDate) : null
    },
  },
  methods: {
    sortDate(a, b) {
      if(a.year === b.year) {
        if(a.start_month === b.start_month) {
          return a.start_day > b.start_day ? 1 : (a.start_day === b.start_day ? 0 : -1)
        } else {
          return a.start_month > b.start_month ? 1 : -1
        }
      } else {
        return a.year > b.year ? 1 : -1
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/periods.js